"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Heading = _interopRequireDefault(require("../Heading"));

var H6 = (0, _styledComponents.default)(_Heading.default).withConfig({
  displayName: "H6",
  componentId: "sc-1v4esg7-0"
})([""]);
H6.propTypes = _Heading.default.propTypes;
H6.defaultProps = Object.assign({}, _Heading.default.defaultProps, {
  tagName: 'h6'
});
H6.displayName = 'H6';
var _default = H6;
exports.default = _default;
module.exports = exports.default;